<template>
  <div id="app">
    <v-app>

      <div class="style_base">
        <v-content>
          <NakedMain />
        </v-content>
        

        <!-- 必要であれば app を入れる
        <v-footer color="#eef0ec">
          <v-container class="text-center">
            <span class="overline black--text font-en"
              >&copy; {{ new Date().getFullYear() }} NAKED, inc.</span
            >
          </v-container>
        </v-footer> -->
      </div>
    </v-app>
  </div>
</template>
<style>
 @font-face {
        font-family: 'cnFont';
        src: url("common/font/SIMHEI.TTF");
    }

 @font-face {
        font-family: 'twFont';
        src: url("common/font/TaipeiSansTCBeta-Regular.ttf");
    }
    @font-face {
        font-family: 'twFont_bold';
        src: url("common/font/TaipeiSansTCBeta-Bold.ttf");
    }
    @font-face {
        font-family: 'krFont';
        src: url("common/font/NanumGothic_0.ttf");
    }
</style>
<style scoped>


@media only screen and (min-width: 320px) {
    html {
      font-size:  62.5% !important;
    }
    }

.style_base {
  background-color: #f8f7f2;
}

.fadein {
  opacity: 1;
  transition: opacity 3s;
}

.fadeout {
  opacity: 0;
  transition: opacity 3s;
}

.slideshow {
  position: absolute;
}

.localize {
  position: absolute;
  top: 0;
  right: 10px;
}

.font-en {
    font-family:"sofia-pro", sans-serif;
    font-weight: 400;
    font-style: normal;
}

</style>

<script>
import isMobile from "ismobilejs";
// import NakedLP from "./components/NakedLP";
import NakedMain from "./components/NakedMain";

export default {
  name: "App",

  components: {
    NakedMain,
  },

  

  data: () => ({
   
    // スライドショー用のインデックス
    index: 0,

    // PCとモバイルを切り替えるためのもの、消さないように
    isMobile,

    isMobileDevice: function () {
      if (isMobile().any) {
        return true;
      }
      return false;
    },
  }),

  computed: {
    key_visual_style() {
      return {
        // 高さは素材に応じて変更
        height: `${(window.innerWidth * 1300) / 1920}px`,
      };
    },

    key_visual_style_sp() {
      return {
        // 高さは素材に応じて変更
        width: window.innerWidth,
        height: `${(window.innerWidth * 736) / 414}px`,
      };
    },
  },

  mounted() {
    // const images = document.getElementsByClassName("slideshow");
    // this.slideshow(images);
    // setInterval(() => {
    //   this.index = this.index < images.length - 1 ? this.index + 1 : 0;

    //   // ループしない
    //   if (this.index > 0) {
    //     this.slideshow(images);
    //   }
    // }, 3000);

    // this.updateHeadData();
  },

  
};
</script>

